/**
 * Farlo UI | Ticket Calendar
 *
 * @author Farlo
 */

class FarloUiTicketCalendar {
	constructor(element, _config) {
		this.container = element;
		this.options = _config;
		this.minDate = new Date(this.container.dataset.startMonth);
		this.maxDate = new Date(this.container.dataset.endMonth);
		if (this.container.dataset && this.container.dataset.startMonth) {
			this.currentDate = new Date(this.container.dataset.startMonth);
		} else {
			this.currentDate = new Date();
		}

		this.render();
	}

	renderHeader() {
		const header = document.createElement('div');
		header.classList.add('site-farlo-ui-ticket-calendar__header');

		const title = document.createElement('h2');
		title.classList.add('site-farlo-ui-ticket-calendar__header-month-year');
		title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
		header.appendChild(title);

		const prevButton = document.createElement('button');
		prevButton.classList.add('site-farlo-ui-ticket-calendar__button', 'site-farlo-ui-ticket-calendar__button--prev', 'button');
		prevButton.textContent = '<';

		if (parseInt(this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString(), 10) >
			parseInt(this.minDate.getFullYear().toString() + this.minDate.getMonth().toString(), 10)) {
			prevButton.classList.remove('site-farlo-ui-ticket-calendar__button-disabled');
			prevButton.addEventListener('click', () => this.prevMonth());
		} else {
			prevButton.classList.add('site-farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(prevButton);

		const nextButton = document.createElement('button');
		nextButton.classList.add('site-farlo-ui-ticket-calendar__button', 'site-farlo-ui-ticket-calendar__button--next', 'button');
		nextButton.textContent = '>';

		if (parseInt(this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString(), 10) <
			parseInt(this.maxDate.getFullYear().toString() + this.maxDate.getMonth().toString(), 10)) {
			nextButton.classList.remove('site-farlo-ui-ticket-calendar__button-disabled');
			nextButton.addEventListener('click', () => this.nextMonth());
		} else {
			nextButton.classList.add('site-farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(nextButton);

		this.container.appendChild(header);
	}

	renderDaysOfTheWeeks() {
		const div = document.createElement('div');
		div.classList.add('site-farlo-ui-ticket-calendar__weeks');
		let daysLetters = '';

		function daysLettersAdjustment() {
			if (window.innerWidth <= 980) {
				daysLetters = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
			} else {
				daysLetters = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
			}

			return daysLetters;
		}

		for (let i = 0; i < 7; i += 1) {
			const days = document.createElement('div');

			days.classList.add('site-farlo-ui-ticket-calendar__week-day');
			days.textContent = daysLettersAdjustment()[ i ];
			div.appendChild(days);
		}

		window.addEventListener('resize', () => {
			daysLettersAdjustment();
		});

		this.container.appendChild(div);
	}

	async fetchEventsForMonth(y, m) {
		let data = {};

		if (typeof farloAjaxVendorHandler.apiKey !== 'undefined' && farloAjaxVendorHandler.apiKey !== '') {
			data = new URLSearchParams({
				action: 'getEventsFromApi',
				nonce: farloAjaxVendorHandler.nonce,
				month: m,
				year: y
			});
		} else if (typeof farloAjaxVendorHandler.calendarData !== 'undefined' && farloAjaxVendorHandler.calendarData.calendarData) {
			data = new URLSearchParams({
				action: 'getEventsForMonth',
				nonce: farloAjaxVendorHandler.nonce,
				month: m,
				year: y,
				custom_data: JSON.stringify(farloAjaxVendorHandler.calendarData.calendarData)
			});
		} else {
			data = new URLSearchParams({
				action: 'getEventsForMonth',
				nonce: farloAjaxVendorHandler.nonce,
				month: m,
				year: y
			});
		}

		this.container.classList.add('site-farlo-ui-ticket-calendar--loading');

		try {
			const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': farloAjaxVendorHandler.nonce
				}
			});

			if (response.ok) {
				const responseData = await response.json();

				this.container.classList.remove('site-farlo-ui-ticket-calendar--loading');

				// Clear the container before adding new content
				this.container.innerHTML = '';
				this.renderHeader();
				this.renderDaysOfTheWeeks();

				if (typeof responseData.data.calendarCells !== 'undefined' && responseData.data.calendarCells !== '') {
					this.container.insertAdjacentHTML('beforeend', responseData.data.calendarCells);

					if (document.querySelector('.site-farlo-ui-ticket-calendar__days-date-opening-hours--closed')) {
						document.querySelectorAll('.site-farlo-ui-ticket-calendar__days-date-opening-hours--closed').forEach((_sel) => {
							_sel.parentNode.classList.add('site-farlo-ui-ticket-calendar__days-day--closed');
						});
					}
				}
			} else {
				console.error('Response status not OK:', response.status);
			}
		} catch (error) {
			console.error('There was an error!', error);
		}
	}

	async render() {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderDaysOfTheWeeks();
		this.fetchEventsForMonth(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1);
	}

	prevMonth() {
		this.currentDate.setMonth(this.currentDate.getMonth() - 1);
		this.render();
	}

	nextMonth() {
		this.currentDate.setMonth(this.currentDate.getMonth() + 1);
		this.render();
	}

	handleEventClick(event) {
		if (this.options.eventClick) {
			this.options.eventClick(event);
		}
	}
}

export default FarloUiTicketCalendar;
